import React, {useState, useEffect} from 'react'
import {
  withStyles,
  TextField,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Button,
  Checkbox,
  InputAdornment,
  InputLabel,
  Menu,
  MenuItem,
} from '@material-ui/core'
import Cookies from 'js-cookie'
import styled from 'styled-components'
import { blue } from '@material-ui/core/colors'
import {ArrowDropUp, ArrowDropDown} from '@material-ui/icons'
import { IoRadioButtonOff, IoRadioButtonOn } from 'react-icons/io5'

const base_url = 'https://api.v2.smartdash.com/smartdash/v1/index.cfm'

const StyledTextField = styled(TextField)({
  '& label': {
    color: '#b5b5b5'
  },
  '& label.Mui-focused': {
    color: '#25aae1'
  },
  '.MuiOutlinedInput-root': {
    color: '#fff',
    fieldset: {
      borderColor: '#b5b5b5',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#25aae1'
    },
  },
})

const StyledMenu = withStyles({
  paper: {
    width: '100%',
    maxWidth: 750,
    maxHeight: 400,
  }
})(props => (
  <Menu
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'left'
    }}
    {...props}
  />
))

export default function UploadForm(props) {
  const {firstName, lastName, address, address2, city, state, zip, inclusion, submit, validationsPassed, locationsList } = props
  const [first, setFirst] = useState(firstName ? firstName : "")
  const [last, setLast] = useState(lastName ? lastName : "")
  const [status, setStatus] = useState(inclusion)
  const [location, setLocation] = useState(address ? address : "")
  const [selectedAddress2, setSelectedAddress2] = useState(address2 ? address2 : "")
  const [selectedCity, setSelectedCity] = useState(city ? city : "")
  const [selectedState, setSelectedState] = useState(state ? state : "")
  const [selectedZip, setSelectedZip] = useState(zip ? zip : "")
  const [locationOpen, setLocationOpen] = useState(false)
  const [newSalesPerson, setNewSalesPerson] = useState({first: firstName ? firstName : "", last: lastName ? lastName : "", locationID: 0, Inclusion: status})
  const [anchor, setAnchor] = useState(null)

  const handleStatusChange = (e) => {
    const {value} = e.target

    setStatus(parseInt(value))
    setNewSalesPerson(prevState => ({...prevState, Inclusion: parseInt(value)}))
  }

  const handleLocationMenuOpen = (e) => {
    const {currentTarget} = e

    setLocationOpen(true)
    setAnchor(currentTarget)
  }

  const handleLocationMenuClose = (e) => {
    setLocationOpen(false)
    setAnchor(null)
  }

  const handleNameInput = (e) => {
    const {name, value} = e.target

    console.log(name)
    console.log(value)
    setNewSalesPerson(prevState => ({...prevState, [name]: value}))
  }

  const setAddress = (locationID) => {
    const selectedLocation = locationsList.filter(({LocationID}) => LocationID === locationID)[0]

    setLocation(selectedLocation.Address1)
    setSelectedAddress2(selectedLocation.Address2)
    setSelectedCity(selectedLocation.City)
    setSelectedZip(selectedLocation.ZIP)
    setSelectedState(selectedLocation.State)
    setNewSalesPerson(prevState => ({...prevState, locationID: locationID}))
    handleLocationMenuClose()
  }

  const handleSubmit = () => {
    submit(newSalesPerson)    
  }

  const handleCancel = () => {
    props.history.push('/sales-consultants')
  }

  const renderMenuOptions = () => (
    locationsList.filter(({Address1}) => Address1 !== "").map(({LocationID, Address1}, i) => (
      <MenuItem onClick={() => setAddress(LocationID)} key={`locations-${i}`}>
        {Address1}
      </MenuItem>
    ))
  )

  return (
    <div>
      <div className="form-name">
        <StyledTextField
          variant="outlined"
          name="first"
          value={newSalesPerson.first}
          label="First Name"
          className="name-field"
          onChange={handleNameInput}
          required
        />
        <StyledTextField
          variant="outlined"
          name="last"
          value={newSalesPerson.last}
          label="Last Name"
          className="name-field"
          onChange={handleNameInput}
          style={{marginLeft: '10px'}}
          required
        />
      </div>
      <br/>
      <div className="form-address">
        <StyledTextField
          variant="outlined"
          name="Address"
          label="Address 1"
          className="address-field"
          onClick={handleLocationMenuOpen}
          value={location}
          InputProps={{
            endAdornment: <InputAdornment position="end">
              {locationOpen ? <ArrowDropUp fontSize="small"/> : <ArrowDropDown fontSize="small"/>}
            </InputAdornment>
          }}
          required
        />
        <StyledMenu
          anchorEl={anchor}
          keepMounted
          open={locationOpen}
          onClose={handleLocationMenuClose}
        >
          {renderMenuOptions()}
        </StyledMenu>
        <StyledTextField
          variant="outlined"
          name="Address2"
          value={selectedAddress2}
          label="Address 2"
          className="address-field"
          style={{marginTop: '15px'}}
        />
        <div className="address-zip">
          <StyledTextField
            variant="outlined"
            value={selectedCity}
            name="City"
            label="City"
            className="zip-field"
            required
          />
          <StyledTextField
            variant="outlined"
            value={selectedState}
            name="State"
            label="State"
            className="zip-field"
            style={{marginLeft: '10px'}}
            required
          />
          <StyledTextField
            variant="outlined"
            value={selectedZip}
            name="ZIP"
            label="Zip Code"
            className="zip-field"
            style={{marginLeft: '10px'}}
            required
          />
        </div>
      </div>
      <br/>
      <div className="inclusion">
        <FormControlLabel
          control={
            <Checkbox
              checked={status === 1}
              onChange={handleStatusChange}
              icon={<IoRadioButtonOff style={{fontSize: '17px'}}/>}
              checkedIcon={<IoRadioButtonOn style={{fontSize:'17px', color: '#6ce68c'}}/>}
              size="small"
              disableRipple
              style={{background: 'transparent', color: '#fff'}}
            />
          }
          label="Include"
          labelPlacement="end"
          value={1}
          style={{color: "#c7c7c7"}}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={status === 2}
              onChange={handleStatusChange}
              icon={<IoRadioButtonOff style={{fontSize: '17px'}}/>}
              checkedIcon={<IoRadioButtonOn style={{fontSize:'17px', color: '#e07977'}}/>}
              size="small"
              disableRipple
              style={{background: 'transparent', color: '#fff'}}
            />
          }
          label="Exclude"
          labelPlacement="end"
          value={2}
          style={{color: '#c7c7c7'}}
        />
      </div>
      <br/>
      <Button variant="outlined" className="submit-btn" onClick={handleSubmit}>SUBMIT</Button>
      <Button className="cancel-btn" href="/sales-consultants" disableRipple>Cancel</Button>
    </div>
  )
}
